import i18n from '../i18n';

export const salesforceAccountMixin = {
  data() {
    return {
      downloadSFCertificateFile: false,
      grantInfo: {
        'Password' : {
          'grant_type': 'password',
          'username': '',
          'password': ''
        },
        'JWT Bearer' : {
          'grant_type': 'urn:ietf:params:oauth:grant-type:jwt-bearer',
          'username': '',
        }
      },
      grantType: '',
      grantTypes: ['Password', 'JWT Bearer'],
      salesforceGrantRules: {
        username: [
          value => !!value || i18n.t('validation.linkTranscriptConfigRules.salesforce.username.isRequired'),
        ],
        password: [
          value => !!value || i18n.t('validation.linkTranscriptConfigRules.salesforce.password.isRequired'),
        ]
      },
      selectedGrantInfo: {},
      showPassword: false,
    };
  },
  methods: {
    downloadSFCertificate(){
      // Preparing .crt file download url
      let hostname = window.location.href;
      let arr = hostname.split("/");
      let url = arr[0] + "//" + arr[2]
      let fileName = (arr[2] === 'crmconnect.navomi.com') ? 'server.crt' : 'dev_server.crt';
      // Creating and injecting new attribute element with download href
      const link = document.createElement('a')
      link.href = `${url}/salesforce_auth/${fileName}`;
      link.setAttribute('download', 'dev_server.crt') //or any other extension
      document.body.appendChild(link)
      link.click()
    },
  },
  watch: {
    selectedGrantInfo: {
      handler:  function (newVal, oldVal) {
        this.downloadSFCertificateFile = false;
        if(this.grantType === 'JWT Bearer' && newVal.username !== '') {
            this.downloadSFCertificateFile = true;
        }
      },
      deep: true
    },
  }
};